export default "__VITE_ASSET__DURJWLFV__"